<template>
    <Fragment>
        <div class="maincontent">
            <div class="textured_bg">
            </div>
            <PageSlide>
                <PlaybackPage
                        ref="playback"
                        :audio-choice="audioChoice"
                        :video-choice="videoChoice"
                        :initiallyVisible=false
                        @restart="onRestart"/>
            </PageSlide>
            <PageSlide>
                <AudioPage
                        ref="audio"
                        :initiallyVisible=false
                        :viewed="viewed"
                        :viewkey="videoChoice+'/'+audioChoice"
                        :reset-count="resetCount"
                        @back-clicked="onBackToVideo"
                        @next-clicked="onGoToPlayback"
                        @choose-audio="onChooseAudio" />
            </PageSlide>
            <PageSlide>
                <VisualsPage
                        ref="visuals"
                        :initiallyVisible=false
                        :reset-count="resetCount"
                        @back-clicked="onBackToLanding"
                        @next-clicked="onGoToAudio"
                        @choose-video="onChooseVideo"/>
            </PageSlide>
            <PageSlide>
                <LandingPage
                        ref="landing"
                        :initiallyVisible=true
                        @begin-clicked="onLandingBeginClicked" />
            </PageSlide>

        </div>

        <header :class="hasBegun?'hasBegun':''">
            <a class="nohref" @click="resetToLanding"><div class="logo-title"></div></a>
            <a target="_blank" href="https://www.scottishdancetheatre.com/"><div class="logo-scottish-dance-theatre"></div></a>
            <a target="_blank" href="https://scottishensemble.co.uk/"><div class="logo-scottish-ensemble"></div></a>
        </header>

        <footer>
            <button @click="showAbout = true" class="btn-about">about</button>
        </footer>

        <AboutOverlay :show=showAbout @close-about="onCloseAbout" />
    </Fragment>
</template>

<script>

    import { Fragment } from 'vue-fragment'

    import PageSlide from './components/PageSlide.vue'
    import LandingPage from "@/components/LandingScreen";
    import VisualsPage from "@/components/VisualsPage";
    import AudioPage from "@/components/AudioPage";
    import PlaybackPage from "@/components/PlaybackPage";
    import AboutOverlay from "@/components/AboutOverlay";

    export default {
        name: 'App',
        components: {
            AboutOverlay,
            PlaybackPage,
            AudioPage,
            VisualsPage,
            LandingPage,
            Fragment,
            PageSlide
        },
        mounted: function() {
            console.log("%c~=~ Site code development: ~=~", "color:green");
            console.log("%c~=~   https://kup.io/sig   ~=~", "color:green");

            var resizeHandler = () => {
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
                document.documentElement.style.setProperty('--vhc', `${vh*100}px`);
            }
            window.addEventListener('resize', resizeHandler);
            window.addEventListener('orientationchange', resizeHandler);
            resizeHandler();
        },
        data() {
        return {
                page: "landing",
                showAbout: false,
                videoChoice: "",
                audioChoice: "",
                viewed: [],
                resetCount: 0,
                hasBegun: false
            }
        },
        methods: {
            onCloseAbout: function() {
                this.showAbout = false;
            },
            onLandingBeginClicked: function() {
                this.$refs.landing.visible = false;
                this.$refs.visuals.visible = true;
                this.hasBegun = true;
            },
            onBackToLanding: function() {
                this.$refs.landing.visible = true;
                this.$refs.visuals.visible = false;
                this.hasBegun = false;
            },
            onGoToAudio: function() {
                this.$refs.visuals.visible = false;
                this.$refs.audio.visible = true;
                this.hasBegun = true;
            },
            onBackToVideo: function() {
                this.$refs.audio.visible = false;
                this.$refs.visuals.visible = true;
                this.hasBegun = true;
            },
            onGoToPlayback: function() {
                this.$refs.audio.visible = false;
                this.$refs.playback.visible = true;
                this.viewed.push(this.videoChoice+"/"+this.audioChoice);
                this.hasBegun = true;
            },
            onChooseVideo: function(choice) {
                this.videoChoice = choice;
            },
            onChooseAudio: function(choice) {
                this.audioChoice = choice;
            },
            onRestart: function() {
                this.$refs.landing.visible = false;
                this.$refs.visuals.visible = true;
                this.$refs.audio.visible = false;
                this.$refs.playback.visible = false;
                this.resetCount = this.resetCount + 1;
                this.videoChoice = "";
                this.audioChoice = "";
                this.hasBegun = true;

            },
            resetToLanding: function() {
                this.$refs.landing.visible = true;
                this.$refs.visuals.visible = false;
                this.$refs.audio.visible = false;
                this.$refs.playback.visible = false;
                this.resetCount = this.resetCount + 1;
                this.videoChoice = "";
                this.audioChoice = "";
                this.hasBegun = false;

            }
        }
    }

</script>

<style lang="scss">

    @import '~normalize.css';
    @import "~@fortawesome/fontawesome-pro/css/all.min.css";
    @import './assets/styles/app.css';

    .logo-title{
        background-image: url('./assets/title@2x.png');
        width: 337px;
        height: 23px;
        display: block;
        background-size: cover;
        background-position: center;
        top: 32px;
        left: 130px;
        position: absolute;

        /* tablet */
        @media only screen and (max-width : 910px) {
            left: 22px;
        }

        /* mobile */
        @media only screen and (max-width : 736px) {
            background-image: url('./assets/title-mob.png');
            width: 359px * 0.25;
            height: 208px * 0.25;
            left: 22px;
            top: 9px;
        }

    }

    .logo-scottish-dance-theatre {
        background-image: url('./assets/Dance Logo@2x.png');
        width: 130px;
        height: 48px;
        display: block;
        background-size: cover;
        background-position: center;
        top: 20px;
        right: 130px;
        position: absolute;

        /* tablet */
        @media only screen and (max-width : 910px) {
            right: 22px;
        }

        /* mobile */
        @media only screen and (max-width : 736px) {
            width: 130px * 0.7;
            height: 48px * 0.7;
            right: 22px;
        }
    }

    .logo-scottish-ensemble {
        background-image: url('./assets/Scottish Ensemble Logo@2x.png');
        width: 112px;
        height: 37px;
        display: block;
        background-size: cover;
        background-position: center;
        top: 25px;
        right: 310px;
        position: absolute;

        /* tablet */
        @media only screen and (max-width : 910px){
            right: 166px;
        }

        /* mobile */
        @media only screen and (max-width : 736px){
            width: 112px * 0.7;
            height: 37px * 0.7;
            right: 136px;
        }
    }

</style>
